import { Action, createReducer, on } from '@ngrx/store';
import isNil from 'lodash-es/isNil';
import { decreaseLoading } from '../utils';
import * as TenantActions from './tenants.actions';
import { TenantState } from './tenants.models';

export let tenantInitialState: TenantState = {
    loading: 0,
    tenants: new Map(),
    initiallyLoaded: false,
};

export const tenantReducer = createReducer(
    tenantInitialState,
    on(TenantActions.loading, (state) => {
        return { ...state, loading: state.loading + 1 };
    }),
    on(TenantActions.loadingDone, (state) => {
        return { ...state, loading: decreaseLoading(state.loading) };
    }),
    on(TenantActions.loadedTenants, (state, { data }) => {
        const tenants = new Map(state.tenants);

        data.forEach((d) => {
            if (!isNil(d.id)) {
                tenants.set(d.id, d);
            }
        });

        return { ...state, initiallyLoaded: true, tenants };
    }),
    on(TenantActions.loadedTenantDetails, (state, { tenant, keycloakId }) => {
        const tenants = new Map(state.tenants);

        if (!isNil(tenant.id)) {
            tenants.set(tenant.id, { ...tenant, keycloakId });
        }

        return { ...state, tenants };
    }),
    on(TenantActions.updatedTenant, (state, { tenant }) => {
        const tenants = new Map(state.tenants);

        if (!isNil(tenant.id)) {
            tenants.set(tenant.id, tenant);
        }
        return { ...state, tenants };
    }),
    on(TenantActions.createdTenant, (state, { tenant }) => {
        const tenants = new Map(state.tenants);

        if (!isNil(tenant.id)) {
            tenants.set(tenant.id, tenant);
        }
        return { ...state, tenants };
    }),
    on(TenantActions.deletedTenant, (state, { id }) => {
        const tenants = new Map(state.tenants);
        tenants.delete(id);
        return { ...state, tenants };
    })
);

export function tenants(state = tenantInitialState, action: Action): TenantState {
    return tenantReducer(state, action);
}
